import { z } from 'zod';
import { skillCategorySchema } from './common.js';
import {
  strapiAwardBaseSchema,
  strapiExperienceBaseSchema,
  strapiProjectBaseSchema,
  strapiSkillBaseSchema,
} from './base.js';

export const strapiAwardSchema = strapiAwardBaseSchema.extend({
  categories: z.array(skillCategorySchema),
  skills: z.array(strapiSkillBaseSchema).nullish(),
  projects: z.array(strapiProjectBaseSchema).nullish(),
  experience: z.array(strapiExperienceBaseSchema).nullish(),
});

export type StrapiAwardResponse = z.infer<typeof strapiAwardSchema>;
